import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f04b273")

_pushScopeId("data-v-4f04b273")
const _hoisted_1 = { class: "new-join-view" }
const _hoisted_2 = { class: "funteambidding-join-game__wrapper" }
const _hoisted_3 = { class: "funteambidding-join-game" }
const _hoisted_4 = { class: "funteambidding-join-game__heading mb3 color-white" }
const _hoisted_5 = { class: "input-wrapper" }
const _hoisted_6 = { for: "name" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = {
  key: 1,
  class: "error"
}
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = { for: "nickname" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('joinGame.createProfile')), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, [
            _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.name')) + "*", 1)
          ]),
          _createVNode(_component_Input, {
            id: "name",
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.name.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true),
          (_ctx.nameTaken)
            ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('joinGame.nameTaken')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('newGame.nickname')), 1),
          _createVNode(_component_Input, {
            id: "nickname",
            type: "text",
            modelValue: _ctx.nickname,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.nickname = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.nickname.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_BaseButtonWithSpinner, {
          disabled: !_ctx.name || _ctx.nameTaken || _ctx.someInputTooLong || _ctx.joinLoading,
          loading: _ctx.joinLoading,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('join', { name: _ctx.name, nickname: _ctx.nickname })))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('joinGame.button')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ])
  ]))
})